import { api } from './client';

export interface Option {
  letter: string;
  text: string;
}

export interface Question {
  id: string;
  dimensionId: string;
  text: string;
  options: Option[];
}

export interface Dimension {
  id: string;
  name: string;
  weight: number;
  questions: Question[];
}

export interface Assessment {
  assessmentId: string;
  userId: string;
  userEmail?: string;
  teamId: string;
  groupId: string;
  groupType: string;
  cadencePeriod: string;
  submittedAt: string;
  totalScore: number;
  maturityLevel: number;
  dimensionScores: Record<string, number>;
}

export interface AssessmentDetail {
  assessment: Assessment;
  responses: Array<{
    responseId: string;
    questionId: string;
    dimensionId: string;
    answer: string;
    score: number;
  }>;
}

export interface SubmitResult {
  assessmentId: string;
  totalScore: number;
  maturityLevel: number;
  dimensionScores: Record<string, number>;
}

export async function getQuestions(): Promise<{ dimensions: Dimension[] }> {
  const r = await api.get<{ dimensions: Dimension[] }>('/assessment/questions');
  return r.data;
}

export async function submitAssessment(
  cadencePeriod: string,
  responses: Array<{ questionId: string; answer: string }>,
): Promise<SubmitResult> {
  const r = await api.post<SubmitResult>('/assessment/submit', { cadencePeriod, responses });
  return r.data;
}

export async function getMyHistory(): Promise<{ assessments: Assessment[] }> {
  const r = await api.get<{ assessments: Assessment[] }>('/assessment/history');
  return r.data;
}

export async function getAssessmentDetail(id: string): Promise<AssessmentDetail> {
  const r = await api.get<AssessmentDetail>(`/assessment/history/${id}`);
  return r.data;
}
